import React, { useEffect } from 'react'
import { useSiteUser } from '../../Users/shared/hooks/UseSiteUser'
import { PositionName } from '../../Positions/shared/PositionName'

interface UserPositionProps {
  userId: string;
}

function UserPosition({ userId }: UserPositionProps) {
  const { siteUser } = useSiteUser(userId)

  if (!siteUser?.positionId) {
    return <span>No position assigned</span>
  }

  return <PositionName id={siteUser.positionId} />
}

export { UserPosition }
